module.exports = __webpack_public_path__ + "img/kompanija3.875bf55f.jpg";